import {DisplayListener, Payment} from "@variocube/app-api";

export interface CurrentPayment {
    amount: number;
    currency: string;
    displayListener: DisplayListener;
    resolve: (payment: Payment) => void;
    reject: (reason: any) => void;
}

export class InitiatePaymentError {
    constructor(public readonly reason: any, public readonly systemError: boolean) {
    }

    toString() {
        return `${this.reason}`;
    }
}